import { clients } from 'lib/https';
import { ConfigurationSettings } from '/models/configuration-settings';

interface IntegrationToken {
    token: string;
}

export interface CreateIntegrationRequest {
    connection_id: string;
    scope: string;
    integration_type: string;
    display_name?: string;
    connection_data?: {
        host?: string;
        port?: number;
        username?: string;
        password?: string;
        private_key?: string | null;
    };
}

export interface Integration {
    _id: string;
    connection_id: string;
    user_id: string;
    org_id: string;
    scope: string;
    integration_type: string;
    status: string;
    sync_status: string;
    display_name: string;
    settings: {
        sync_interval: string;
        folders_included: string[];
        folders_excluded: string[];
    };
    created_at: string;
    updated_at: string;
    last_synced_at: string | null;
    integration_type_metadata: any;
    error_info: any;
    is_active: boolean;
}

export interface IntegrationLimitResponse {
    allowed: boolean;
    limit_type: string;
    current_usage: number;
    limit_value: number;
    remaining: number;
    message: string | null;
}

export const getIntegrationToken = async (
    config: ConfigurationSettings
): Promise<IntegrationToken> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.integrationToken}`;
    return clients.get(url, config.blocksKey);
};

export const createIntegration = async (
    config: ConfigurationSettings,
    payload: CreateIntegrationRequest
): Promise<Integration> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.integrations}`;
    // eslint-disable-next-line no-console
    console.log('Creating integration at URL:', url);
    return clients.post(url, config.blocksKey, JSON.stringify(payload));
};

export const getIntegrations = async (
    config: ConfigurationSettings
): Promise<Integration[]> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.integrations}`;
    // eslint-disable-next-line no-console
    console.log('Getting integrations from URL:', url);
    return clients.get(url, config.blocksKey);
};

export const deleteIntegration = async (
    config: ConfigurationSettings,
    connectionId: string,
    integrationType?: string
): Promise<void> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    let url = `${baseUrl}${config.paths.taskforce.integrations}/${connectionId}`;
    
    // Add hard_delete=true parameter only for SFTP
    if (integrationType === 'sftp') {
        url += '?hard_delete=true';
    }
    
    // eslint-disable-next-line no-console
    console.log('Deleting integration at URL:', url);
    return clients.delete(url, config.blocksKey);
};

export const syncIntegration = async (
    config: ConfigurationSettings,
    connectionId: string
): Promise<{ success: boolean; message: string }> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.integrationSync}`;
    // eslint-disable-next-line no-console
    console.log('Syncing integration at URL:', url);
    return clients.post(url, config.blocksKey, JSON.stringify({ connection_id: connectionId }));
};

export const checkIntegrationLimit = async (
    config: ConfigurationSettings
): Promise<IntegrationLimitResponse> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.integrationLimit}`;
    // eslint-disable-next-line no-console
    console.log('Checking integration limit at URL:', url);
    return clients.get(url, config.blocksKey);
};
